import React from 'react';
import landmark from '../../images/intro-img.jpeg';

const isBrowser = typeof window !== 'undefined';

const IntroHeaderSec = () => {
  return (
    <section
      className="intro-header-wrapper pt-5 d-flex center column"
      data-aos="fade-up" data-aos-duration="900"
      style={{
        backgroundImage: `linear-gradient(rgba(61,66,74,0.7), rgba(61,66,74,0.7)), url(${landmark})`
      }}
    >
      <div className="intro-text-container text-white text-center mt-5">

        <h1 className="mb-5 caps fw-700 intro-heading animate__animated animate__rotateInUpLeft text-900"
        style={{ animationDuration: '1s' }}>
          The <span className="green-c">best</span> growing medium solutions for plants
        </h1>
      </div>
      <div className="pt-4 text-center animate__animated animate__rotateInUpRight"
      style={{ animationDuration: '1s' }}>
        <a href="#" className="btn btn-primary p-4 py-3 green-bg border-0 caps text-sm fw-600 intro-btns m-1 shadow-5"
        onClick={(ev) => {
          ev.preventDefault();
          isBrowser ? document.querySelector('#products-preview').scrollIntoView() : null;
        }}>
          Products <i className="pi pi-arrow-right ms-3" style={{ fontSize: '0.60rem' }}></i>
        </a>{' '}
        <a href="#" className="btn surface-900 p-4 py-3 text-white border-0 caps text-sm fw-600 gray-bg intro-btns m-1 shadow-5"
        onClick={(ev) => {
          ev.preventDefault();
          isBrowser ? document.querySelector('#footer').scrollIntoView() : null;
        }}>
          Contact Us <i className="pi pi-arrow-right ms-3" style={{ fontSize: '0.60rem' }}></i>
        </a>
      </div>
    </section>
  );
};

export default IntroHeaderSec;
